import { useAuthContext } from '../../context/auth/auth'
import { isLimitedMode } from './limitedMode'
import useCurrentSubscription from './useCurrentSubscription'

/**
 * The single source of truth for read-only mode. Every control that writes
 * something reads `isLimited` from here, so nothing can disagree with the
 * backend's `HasActiveSubscription` about who is blocked.
 */
const useLimitedMode = () => {
  const { userType, token } = useAuthContext()
  const { data: subscription, isLoading } = useCurrentSubscription()

  // Anonymous visitors - a whistleblower filing or following up on a report -
  // are never in limited mode; the backend lets them through on purpose, and
  // there is no subscription to read without a token.
  if (!token) {
    return { isLimited: false, subscription: null, isLoading: false }
  }

  return {
    isLimited: isLimitedMode({ subscription, userType }),
    subscription: subscription ?? null,
    isLoading,
  }
}

export default useLimitedMode
